<template>
  <form class="usa-form">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend">
        Date Modified Search Criteria
      </legend>
      <div
        class="usa-radio"
        v-for="radioOption in radioOptions"
        :key="radioOption.id"
      >
        <input
          class="usa-radio__input"
          :id="radioOption.value"
          type="radio"
          name="last-modified"
          :value="radioOption.return"
          @input="$emit('update:modelValue', $event.target.value)"
        />
        <label class="usa-radio__label" :for="radioOption.value">{{
          radioOption.display
        }}</label>
      </div>
    </fieldset>
  </form>
</template>
<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    radioOptions: {
      type: [Array, Object],
      required: true,
    },
  },
};
</script>
